// Journey types ordered from most important to least
// https://app.clickup.com/1227173/1273459/t/a01qp
/**
 * List of Journey events
 *
 * @category Constants
 * @category Events
 */
export const journeyEventTypes = [
  'referrals',
  'appointments',
  'diagnoses',
  'procedures',
  'feedbackResponses',
  'insurances',
  'recalls',
  'patientForms',
  'billingTransactions',
];
